const IconsJSON = require('./selection.json')

export default IconsJSON
